// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 898) return "static/css/898.446f8c36d1417c7c40f8.lib.css";
	if (chunkId === 32) return "static/css/32.70632196c3feb49c9f22.css";
	// return url for filenames based on template
	return undefined;
};